import { Icon, AdaLink } from '@betrybe/ada-react';
import { ReactElement, useContext } from 'react';
import { useHistory } from 'react-router-dom';
import * as Sentry from '@sentry/browser';
import useLazyTrack from '@/hooks/tracking/useLazyTrack';
import { ActorTypeEnum, SourceEnum, VerbEnum } from '@/tracker/enums';
import { StudentContext } from '@/contexts/index';
import { useClient, useStateMachine } from '@/hooks';
import StatesEnum from '@/utils/enums/StatesEnum';
import { useMscPipeline, useGuarantor } from '@/services/pre-enrollment';

function CardShapedButton(): ReactElement {
  const track = useLazyTrack();
  const { state, setState } = useContext(StudentContext);
  const {
    clientId,
    currentState,
    processInfo,
    selectionProcessId,
    stateMachineVersion,
    mscPipelineId,
    setActualState,
  } = useClient();
  const history = useHistory();
  const { changeMscPipeline } = useMscPipeline();
  const { deleteGuarantors } = useGuarantor();
  const { getStateObject } = useStateMachine();
  const isV3 = stateMachineVersion === 'V3';

  const handleClick = () => {
    track(
      'Guarantor Submission Started',
      {
        actor: {
          user_id: clientId,
          type: ActorTypeEnum.CANDIDATE,
          role: '',
        },
        object: {
          path: window.location.pathname,
          url: window.location.href,
          component: 'Cadastrar duas pessoas avalistas',
          process_info: processInfo,
        },
        context: {
          source: SourceEnum.FINANCING_REQUEST,
        },
        verb: VerbEnum.CLICK,
      },
      'track',
    );

    const stateObj = getStateObject({ state: currentState });

    if (
      currentState === StatesEnum.DISAPPROVED ||
      currentState === StatesEnum.CREDIT_DISAPPROVED
    ) {
      deleteGuarantors(clientId, selectionProcessId)
        .then(async () => {
          if (stateObj && stateObj.nextState) {
            await setState({
              ...state,
              step: stateObj.nextState,
              guarantorsPerson: [],
            });
            await setActualState(stateObj.nextState);
            history?.push(stateObj.nextUrl);
          }
        })
        .catch((err) => {
          const payload = {
            userId: clientId,
            currentState,
          };
          Sentry.setUser({ id: clientId });
          Sentry.captureException({ err, payload });
        });
    } else if (currentState === StatesEnum.GUARANTOR_REGISTRATION) {
      changeMscPipeline({
        mscPipelineId,
        selectionProcessId,
        event: StatesEnum.REGISTER_GUARANTOR,
      })
        .then(() => {
          if (stateObj && stateObj.nextState) {
            history?.push(stateObj.nextUrl);
          }
        })
        .catch((err) => {
          const payload = {
            userId: clientId,
            currentState,
          };
          Sentry.setUser({ id: clientId });
          Sentry.captureException({ err, payload });
        });
    } else if (currentState === StatesEnum.SCORE_DISAPPROVED) {
      changeMscPipeline({
        mscPipelineId,
        selectionProcessId,
        event: StatesEnum.REGISTER_GUARANTOR,
      })
        .then(async () => {
          if (stateObj && stateObj.nextState) {
            await setActualState(stateObj.nextState);
            history?.push(stateObj.nextUrl);
          }
        })
        .catch((err) => {
          const payload = {
            userId: clientId,
            currentState,
          };
          Sentry.setUser({ id: clientId });
          Sentry.captureException({ err, payload });
        });
    } else if (stateObj && stateObj.nextState) {
      history?.push(stateObj.nextUrl);
    }
  };

  const cardText = () => {
    if (isV3 || state.paymentMethod === 'fifteen_delay') {
      if (
        currentState === StatesEnum.SCORE_DISAPPROVED ||
        currentState === StatesEnum.SECOND_GUARANTOR_REGISTRATION
      ) {
        return 'Cadastrar mais uma pessoa avalista';
      }
      return 'Cadastrar primeira pessoa avalista';
    }
    return 'Cadastrar duas pessoas avalistas';
  };

  return (
    <AdaLink onClick={handleClick} id="ada-link">
      <div className="card-shaped-button-container">
        <div className="card-shaped-button-container__icon-div">
          <Icon
            className="card-shaped-button-container__icon-div--icon-color"
            name="add"
          />
        </div>
        <p className="card-shaped-button-container__p-text">{cardText()}</p>
      </div>
    </AdaLink>
  );
}

export default CardShapedButton;
